module.exports = __webpack_public_path__ + "static/img/9.01b7149.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/9.png
// module id = rb8l
// module chunks = 0